require('./dataSetEditorNav.i18n.json');
require('./dataSetEditorNav.tpl.html');
require('./dataSetEditorNavController.js');

const DataSetEditorNavComponent = {
    templateUrl: '/configuration/dataSetEditor/nav/dataSetEditorNav.tpl.html',
    controller: 'dataSetEditorNavController',
    bindings: {}
};

angular.module('ums')
    .component('uiDataSetEditorNav', DataSetEditorNavComponent);
